import { z } from 'zod';
import { INTEGRATION_TYPES } from '../integrations.constants';

export const SIEM_EVENT_TYPES = {
  FINDING_CREATED: 'finding_created',
  SCAN_STARTED: 'scan_started',
  SCANNER_IPS_UPDATED: 'scanner_ips_updated',
  INTERNAL_NETWORK_OPERATION: 'internal_network_operation',
} as const;

export type SiemEventType =
  (typeof SIEM_EVENT_TYPES)[keyof typeof SIEM_EVENT_TYPES];

export const SiemProviderSchema = z.enum([
  INTEGRATION_TYPES.SPLUNK,
  INTEGRATION_TYPES.CROWDSTRIKE_NG_SIEM,
  INTEGRATION_TYPES.CORTEX_XSIAM,
]);

export type SiemProvider = z.infer<typeof SiemProviderSchema>;

export const SiemProviderParamSchema = z.object({
  provider: SiemProviderSchema,
});

export const XsiamApiKeySecurityLevelSchema = z.enum(['standard', 'advanced']);

export type XsiamApiKeySecurityLevel = z.infer<
  typeof XsiamApiKeySecurityLevelSchema
>;

export const SiemConnectBodySchema = z.object({
  url: z.string().min(1),
  apiKey: z.string().min(1),
  apiKeyId: z.string().min(1).optional(),
  index: z.string().optional(),
  sourcetype: z.string().optional(),
  xsiamApiKeySecurityLevel: XsiamApiKeySecurityLevelSchema.optional(),
});

export type SiemConnectBody = z.infer<typeof SiemConnectBodySchema>;

export const SiemProviderMetaSchema = z.object({
  url: z.string().min(1),
  apiKeyId: z.string().min(1).optional(),
  index: z.string().optional(),
  sourcetype: z.string().optional(),
  xsiamApiKeySecurityLevel: XsiamApiKeySecurityLevelSchema.optional(),
});

export type SiemProviderMeta = z.infer<typeof SiemProviderMetaSchema>;

export const SiemConnectionStatusResponseSchema = z.object({
  provider: SiemProviderSchema,
  status: z.enum(['VALID', 'EXPIRED', 'REVOKED', 'NOT_CONNECTED']),
  url: z.string().nullable(),
  pushFindingsEnabled: z.boolean(),
});

export type SiemConnectionStatusResponse = z.infer<
  typeof SiemConnectionStatusResponseSchema
>;

export const SiemErrorBodySchema = z.object({
  message: z.string().optional(),
});
